module.exports = __webpack_public_path__ + "media/images/game_icon/en/VGPHOENIX-a0bc9ab03bd30ac3bcf90a987ca6eb2c.png";